import React from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-Q3X8LKX6GF';

export default function useAnalyticsPageTracking() {
    const location = useLocation();

    React.useEffect(() => {
        if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
            return;
        }

        window.gtag('event', 'page_view', {
            page_path: location.pathname + location.search,
            page_location: window.location.href,
            page_title: document.title,
            send_to: GA_MEASUREMENT_ID,
        });
    }, [location.pathname, location.search]);
}